import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Spin, notification } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialCard from "./testimonial-card";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch("https://api.therealrealtor.lk/api/get-testimonials");
        console.log("Fetch response status:", response.status);
        console.log("Fetch response url:", response.url);
        const contentType = response.headers.get("content-type");
        console.log("Details Content-Type:", contentType);

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Failed to fetch testimonials: ${response.status} ${response.statusText}`);
        }

        if (!contentType || !contentType.includes("application/json")) {
          const text = await response.text();
          console.error("Testimonials ERROR: Received HTML/Text instead of JSON:", text.substring(0, 200));
          throw new Error("Server returned HTML instead of JSON. Check backend.");
        }

        const data = await response.json();

        if (Array.isArray(data)) {
          setTestimonials(data);
        } else {
          console.error("Testimonials data is not an array:", data);
          setTestimonials([]);
        }

      } catch (error) {
        console.error("TESTIMONIALS FETCH ERROR (Silenced):", error);
        // Silencing error notification as per user request
      } finally {
        setIsLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (isLoading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div
      className={
        "w-full px-4 py-6 md:px-6 md:py-10 lg:px-8 lg:py-20 mx-auto text-center overflow-hidden bg-[#e6ce9f]/20 "
      }
    >
      <motion.h1
        variants={{
          hidden: {
            opacity: 0,
            y: -20,
          },
          show: {
            y: 0,
            opacity: 1,
            transition: {
              type: "keyframes",
              duration: 0.2,
              delay: 0.2,
            },
          },
        }}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.6 }}
        className={
          "mb-6 text-xl md:text-4xl lg:text-6xl transition-all ease-in-out duration-500 uppercase font-semibold md:font-bold text-[#272c63] tracking-widest title-font"
        }
      >
        Testimonials
      </motion.h1>

      <motion.p
        variants={{
          hidden: {
            opacity: 0,
            y: -30,
          },
          show: {
            y: 0,
            opacity: 1,
            transition: {
              type: "keyframes",
              duration: 0.4,
              delay: 0.3,
            },
          },
        }}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.6 }}
        className={
          "mb-6 md:mb-8 lg:mb-10 font-semibold italic tracking-widest text-[#272c63]"
        }
      >
        What they say about us!
      </motion.p>

      <Slider {...settings}>
        {testimonials.map((testimonial) => (
          <TestimonialCard
            key={testimonial.id}
            image={`https://api.therealrealtor.lk/api/${testimonial.image}`}
            message={testimonial.review}
            name={testimonial.fullname}
            role={testimonial.designation}
            company={testimonial.company}
          />
        ))}
      </Slider>

    </div>
  );
};

export default Testimonials;